import { timeLabel } from './mascot-game-view'
import styles from './MascotGame.module.css'

export function ActionCountdown({
  seconds,
  label = 'Disponível em',
}: {
  seconds: number
  label?: string
}) {
  const time = timeLabel(seconds)
  return (
    <span className={styles.countdown} role="timer" aria-live="off">
      <span className={styles.countdownRow}>
        <svg className={styles.countdownClock} viewBox="0 0 32 32" aria-hidden="true">
          <circle
            cx="16"
            cy="16"
            r="13"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            opacity=".25"
          />
          <circle
            className={styles.clockOrbit}
            cx="16"
            cy="16"
            r="13"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeDasharray="22 60"
            strokeLinecap="round"
          />
          <path
            d="M16 8v8l5 3"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
        <span className={styles.countdownCopy}>
          <span>{label}</span> <strong key={time}>{time}</strong>
        </span>
      </span>
      <span className={styles.countdownTrack} aria-hidden="true">
        <span />
      </span>
    </span>
  )
}
